export interface AssociatedMedias {
    medias?: string[],
    first?: string,
    second?: string, 
    third?: string
}

export function removeRefsInAssociatedMedias(associatedMedias: AssociatedMedias, refs: string[]): AssociatedMedias {
    let res = {...associatedMedias}
    const principalMediaKeys = ['first', 'second', 'third']

    if(res.medias) {
        res.medias = res.medias.filter(mediaId => !refs.includes(mediaId))
    }

    for(const key of principalMediaKeys) {
        if(res[key] && refs.includes(res[key]) ) {
            res[key] = undefined
        }
    }

    return res
}